import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from "@angular/forms";

import { CustomValidators } from 'ng2-validation';

import { INofesh } from "../model/nofesh";
import { INirsham } from "../model/nirsham";
import { INofeshOrderNirshamim } from "../model/nofesh-order-nirshamim";
import { NofeshService } from "../nofesh.service";
import { MenuHandler } from "app/shared/menu-handler";
import { DateService } from "app/shared/date.service";

declare var $: any;



@Component({
    moduleId: module.id,
    templateUrl: './order-nofesh.component.html'
})

export class OrderNofeshComponent implements OnInit {

    constructor(private _activateRoute: ActivatedRoute, private _router: Router, private fb: FormBuilder, private _http: NofeshService, private ds: DateService) { }
    nofesh: INofesh;
    nofeshId: number;
    errorMessage: string;
    is_submited: boolean = false;
    isvalidform: boolean = true;
    is_nofesh_full: boolean = false;
    nirshamim: INirsham[];

    form: FormGroup;

    ngOnInit() {
        document.getElementById('menuDiv').style.display = 'block';
        MenuHandler.menuHandler($(".wiz_group"), $("#li_hazmanat_nofesh"));

        this.nofeshId = this._activateRoute.snapshot.params['id'];
        if (this.nofeshId == null || this.nofeshId == undefined || this.nofeshId == 0) 
        {
            this._router.navigateByUrl('/nofesh');
            return;
        }

        var nofashim = JSON.parse(sessionStorage.getItem('nofashim')) as INofesh[];
        if (!nofashim) 
        {
            this._router.navigateByUrl('/nofesh');
            return;
        }
        
        this.nofesh = nofashim.find(r => r.id_nofesh == this.nofeshId);
       // console.log(this.nofesh)
        if (!this.nofesh)
        {
            this._router.navigateByUrl('/nofesh');
            return;
        }


        this.form = this.fb.group({
            id_nofesh: [this.nofeshId, Validators.required],
            nirshamim: this.fb.array([
            ])
        })

        this._http.getNofeshNirshamim(this.nofeshId)
            .subscribe((nirshamim: INirsham[]) => {
                this.nirshamim = nirshamim;
                if (nirshamim.length > 0) 
                {
                    nirshamim.forEach((nirsham, index) => {
                        this.addNirsham(nirsham, index);
                    });
                }
                this.form.patchValue(nirshamim);
            }
            , error => {
                if (error.includes("401")) {
                    localStorage.removeItem("token");
                    location.reload();
                }
            }
        );
    }

    initNirshamim(nirsham: INirsham, index: number) {
        //console.log(index, nirsham);
        //debugger
        // TODO: check both flows
        if (nirsham) 
        {
            let tr_leida = nirsham.tr_leida != null ? new Date(nirsham.tr_leida) : null;
            let tr_tokef_darkon = nirsham.tr_tokef_darkon != null ? new Date(nirsham.tr_tokef_darkon) : null;

            let f = this.fb.group({
                ms_zehut: [nirsham.ms_zehut, Validators.required],
                tr_leida: [{ value: '', disabled: index === 0 }, Validators.required],
                shem_prati: [nirsham.shem_prati, Validators.required],
                shem_mishpacha: [nirsham.shem_mishpacha, Validators.required],
                ms_darkon: [nirsham.ms_darkon, Validators.required],
                tr_tokef_darkon: ['', Validators.required],
                shem_prati_loazi: [nirsham.shem_prati_loazi, Validators.required],
                shem_mishpacha_loazi: [nirsham.shem_mishpacha_loazi, Validators.required],
                phone: [nirsham.phone, Validators.required],
                gender: [{ value: nirsham.gender, disabled: index === 0 }, Validators.required],
                email: [nirsham.email, [CustomValidators.email]],
                llo_nitsul_zakaut: [nirsham.llo_nitsul_zakaut]

            });
            if (tr_leida) {
                f.patchValue({
                    tr_leida: new Date(tr_leida.getFullYear(), tr_leida.getMonth(), tr_leida.getDate())
                })
            }

            if (tr_tokef_darkon) {
                f.patchValue({
                    tr_tokef_darkon: new Date(tr_tokef_darkon.getFullYear(), tr_tokef_darkon.getMonth(), tr_tokef_darkon.getDate())
                })
            }
            return f;
        }
        else {
            return this.fb.group({
                ms_zehut: ['', Validators.required],
                tr_leida: ['', Validators.required],
                shem_prati: ['', Validators.required],
                shem_mishpacha: ['', Validators.required],
                ms_darkon: ['', Validators.required],
                tr_tokef_darkon: ['', Validators.required],
                shem_prati_loazi: ['', Validators.required],
                shem_mishpacha_loazi: ['', Validators.required],
                phone: ['', Validators.required],
                gender: ['', Validators.required],
                email: ['', [CustomValidators.email]],
                llo_nitsul_zakaut: [0]
            });
        }
    }

    addNirsham(nirsham: INirsham, index: number) {
        
        const control = <FormArray>this.form.controls['nirshamim'];

        
/*
        setTimeout(_ => {
            console.log(control.value);
        }, 0);
*/

        if(control.controls.length==1)
        {
            //control.controls.
        }
        control.push(this.initNirshamim(nirsham, index));
        //console.log('nirsham ms_zehut ',nirsham.ms_zehut)
    }

    removeNirsham(i: number) {
        const control = <FormArray>this.form.controls['nirshamim'];
        control.removeAt(i);
    }

    save(event, { value, valid }: { value: any, valid: boolean }): void {
        event.preventDefault();
        this.is_submited = true;
        this.errorMessage = null;

        if (!valid) {
            this.isvalidform = false;
            this.errorMessage = 'נא למלא את כל שדות החובה באופן תקין';
            this.is_submited = false;
            return;
        }

        value.nirshamim.forEach((e, index) => {
            if (this.form.value.nirshamim[index].tr_leida && index > 0) {
                let d: Date = this.form.value.nirshamim[index].tr_leida;
                e.tr_leida = this.ds.setUTCDate(d);
            }
            if (this.form.value.nirshamim[index].tr_tokef_darkon) {
                let f: Date = this.form.value.nirshamim[index].tr_tokef_darkon;
                e.tr_tokef_darkon = this.ds.setUTCDate(f);
            }
        });
        
        console.log(this.form.get('nirshamim'))

        this._http.saveNofeshNirshamim(value)
            .subscribe(r => {
                if (r.status) 
                {
                    // Put the object into storage
                    sessionStorage.setItem('order-nofesh', JSON.stringify(r));
                    this._router.navigate(['nofesh', 'nofesh-payment']);
                    return;
                }

                if (r.id_reservation == -1) {
                    this.isvalidform = false;
                    this.is_nofesh_full = true;
                    this.errorMessage = r.returnMessage;
                }
                else {
                    this.isvalidform = false;
                    this.is_submited = false;
                    this.errorMessage = r.returnMessage;
                }
            },
                error => {
                    console.log(error);
                    if (error.includes("401")) {
                        localStorage.removeItem("token");
                        location.reload();
                    }

                    this.isvalidform = false;
                    if (error.indexOf("מיועד לעמיתים") !== -1) {
                        this.errorMessage = 'נופש ללא זכאות מיועד לעמיתים בלבד';
                    }
                    else {
                        this.errorMessage = 'נא לבדוק שכל השדות מולאו כפי שצריך או לנסות מאוחר יותר';
                    }
                    this.is_submited = false;
                })
    }
}